import { Record as record } from 'immutable';

import Station from './Station';
import trainTime from '../lib/TrainTime';
import { construct, fields, resolve } from '../helpers/LinkMapper';
import { getDefaults, getResolvers } from '../helpers/Records';
import { serialize, serializers } from '../helpers/SearchUrls';

const fieldSchema = {
    id: [fields.number],
    trainUid: [fields.number],
    origin: [resolve.as(Station)],
    destination: [resolve.as(Station)],
    departureTime: [resolve.with(time => trainTime(time, 'HH:mm:ss'))],
    arrivalTime: [resolve.with(time => trainTime(time, 'HH:mm:ss'))],
    groupId: [fields.number],
    legOrder: [fields.number],
};

class DisruptionAlertLeg extends record(
    getDefaults(fieldSchema)
) {
    static fromJSON (json = {}) {
        return construct(DisruptionAlertLeg, json, getResolvers(fieldSchema));
    }

    toJSON () {
        return serialize({
            journeyLegId: (_, alert) => alert.id ? alert.id : null,
            trainUid: serializers.identity,
            origin: serializers.stationCrs,
            destination: serializers.stationCrs,
            departureTime: serializers.time,
            arrivalTime: serializers.time,
            groupId: serializers.identity,
            legOrder: serializers.identity,
        }, this);
    }
}

export default DisruptionAlertLeg;



// WEBPACK FOOTER //
// ./src/records/DisruptionAlertLeg.js